import { GET_LIST_ACARA_PERSONAL, GET_DETAIL_ACARA_PERSONAL, RESET_LIST_ACARA_PERSONAL } from "shared/constants/ActionTypes";

const initialState = {
    listAcara: null,
    detail: null,
}

const kalenderPersonalReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LIST_ACARA_PERSONAL:
            return {
                ...state,
                listAcara: action.payload
            }
        case GET_DETAIL_ACARA_PERSONAL:
            return {
                ...state,
                detail: action.payload
            }
        case RESET_LIST_ACARA_PERSONAL: 
            return {
                ...state,
                listAcara: null,
            }
        default:
            return state;
    }
}

export default kalenderPersonalReducer